var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickupcheckouticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6543 9.9347L7.93984 8.88772C8.00693 8.64173 8.18931 8.44364 8.42893 8.3565L9.48607 7.97209L10.9253 7.44873M10.9253 7.44873L10.6905 10.2665C10.6733 10.473 10.7384 10.678 10.8717 10.8366L13.315 13.7453C13.3786 13.821 13.4273 13.9081 13.4586 14.002L14.458 17.0001M10.9253 7.44873L12.3746 9.26034C12.4526 9.35779 12.5628 9.42417 12.6854 9.44752L15.2431 9.9347",
    stroke: "black",
    strokeWidth: 1.57009,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7107,
    cy: 4.57009,
    r: 1.57009,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.6073L8.9205 14.8068C9.03328 14.7011 9.11234 14.5644 9.14775 14.4139L9.61681 12.4204",
    stroke: "black",
    strokeWidth: 1.57009,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupcheckouticon);
export default __webpack_public_path__ + "static/media/pickupcheckouticon.a3bcf3e67a849a92acf9aa9519f73b15.svg";
export { ForwardRef as ReactComponent };